export function formatScreenName(screenName: string) {
  let formattedScreenName;
  // Casos especiais
  switch (true) {
    case screenName === '/auth/authError':
      formattedScreenName = 'VivaAuthError';
      break;
    case screenName === '/missions/missionsList':
      formattedScreenName = 'VivaMissionsList';
      break;
    case screenName.startsWith('/missions/missionInvoice'):
      formattedScreenName = 'VivaMissionInvoice';
      break;
    case screenName.startsWith('/missions/missionCheckIn'):
      formattedScreenName = 'VivaMissionCheckIn';
      break;
    case screenName.startsWith('/missions/missionQuiz'):
      formattedScreenName = 'VivaMissionQuiz';
      break;
    case screenName.startsWith('/missions/missionQuizQuestions'):
      formattedScreenName = 'VivaMissionQuizQuestions';
      break;
    case screenName === '/onboarding/onboarding':
      formattedScreenName = 'VivaOnboarding';
      break;
    case screenName === '/onboarding/onboardingSteps':
      formattedScreenName = 'VivaOnboardingSteps';
      break;
    case screenName === '/onboarding/onboardingEnding':
      formattedScreenName = 'VivaOnboardingEnding';
      break;
    case screenName === '/myInterests/myInterestsInvite':
      formattedScreenName = 'VivaMyInterestsInvite';
      break;
    case screenName === '/myInterests/myInterestsQuiz':
      formattedScreenName = 'VivaMyInterestsQuiz';
      break;
    case screenName === '/myInterests/myInterestsResult':
      formattedScreenName = 'VivaMyInterestsResult';
      break;
    case screenName.startsWith('/missions/missionCarPlate'):
      formattedScreenName = 'VivaMissionCarPlate';
      break;
    case screenName.startsWith('/missions/missionInstant'):
      formattedScreenName = 'VivaMissionInstant';
      break;
    case screenName.startsWith('/benefits/benefitsList'):
      formattedScreenName = 'VivaBenefitsList';
      break;
    case screenName.startsWith('/home'):
      formattedScreenName = 'VivaEntry';
      break;
    default:
      formattedScreenName = `Viva${screenName
        .split('/')
        .map((segment) => {
          const cleanSegment = segment.replace(/[a-f0-9]{24,}/gi, '');
          return cleanSegment.charAt(0).toUpperCase() + cleanSegment.slice(1);
        })
        .filter((segment) => segment)
        .join('')
        }`;
  }
  return formattedScreenName;
}